import moment from "moment";

export const roundTimeSeconds = (value) => {
  // where value = 'PT3H1M59.7S'
  return moment.duration(value).toJSON();
};